<template>
  <v-app>
    <v-navigation-drawer dark v-model="drawer" app>
      <Drawer />
    </v-navigation-drawer>
    <v-app-bar color="primary" dark flat app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $router.currentRoute.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div
        v-if="
          $route.name == 'Sales' ||
          $route.name == 'Stocks' ||
          $route.name == 'Sales by Shop'
        "
        class="text-right"
      >
        <v-btn
          style="text-transform: none"
          text
          depressed
          class="pa-1"
          @click="exportData()"
        >
          <v-icon medium>mdi-file-export</v-icon>
          Export
        </v-btn>
      </div>

      <div v-if="$route.name == 'Shops'" class="text-right">
        <v-btn
          style="text-transform: none"
          text
          depressed
          class="pa-1"
          @click="addShop()"
        >
          <v-icon medium>mdi-plus</v-icon>
          Add Shop
        </v-btn>
      </div>
    </v-app-bar>
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <!-- If using vue-router -->
      <router-view name="dialog"></router-view>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<script>
import Drawer from "./_drawer";

export default {
  data() {
    return {
      drawer: false,
    };
  },
  components: {
    Drawer,
  },
  created() {
    // this.$router.push("/dashboard").catch(() => {});
  },
  methods: {
    exportData() {
      this.$root.$emit("exportData");
    },
    // addShop() {
    //   this.$router.push("/addShop");
    // },
    addShop() {
      this.$root.$emit("addShop");
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$auth.check()) vm.$router.push("/login");
      if (to.name == "Home") {
        vm.$router.push("/dashboard");
      }
    });
  },
};
</script>
